import { useBunja } from 'bunja/react';

import { FormattedMessage } from '@flipster/i18n';

import 'date-fns';

import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { convertDate, formatDatetime } from '@flipster/utils/datetime';
import { numberFormatter } from '@flipster/utils/num';

import { userPoolBunja } from '../user-pool.state';

const formatDateRange = (startTimeStr: string, endTimeStr: string): string => {
  const startDate = convertDate(startTimeStr);
  const endDate = convertDate(endTimeStr);

  if (!startDate || !endDate) return 'Coming Soon';

  const startFormatted = formatDatetime(startDate, { format: 'MMM d', isUTC: true });
  const endFormatted = formatDatetime(endDate, { format: 'MMM d', isUTC: true });

  return `${startFormatted} - ${endFormatted}`;
};

const PoolHeader = () => {
  const { userPoolDataAtom } = useBunja(userPoolBunja);
  const pool = useAtomValue(userPoolDataAtom);

  if (!pool) return null;

  return (
    <div className={vstack({ textAlign: 'center' })}>
      <p className={css({ textStyle: 'Text/M/Strong', color: 'content.default.level-2' })}>
        {formatDateRange(pool.startTime, pool.endTime)}
      </p>
      <h1 className={css({ textStyle: 'Display/XL', color: 'inverse.white', mt: 8 })}>
        {numberFormatter(pool.totalReward)} Pool
        <br /> only for new joiners
      </h1>
      <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-1', mt: 12 })}>
        <FormattedMessage id='Autogen_common.r251126.s_Get_multiplied_rewards_with_missions' />
      </p>
    </div>
  );
};

export default PoolHeader;
